import {
  DELETE_REPOSIT_NOTE_API_SUCCESS,
  FETCH_TENANCY_ORDER_NOTES_API_SUCCESS,
  RepositActionTypes,
} from '../../reposit/reposit.actions';
import { EntityState } from '../entities.types';

export const tenancyOrderEntityReducer = (state: EntityState['tenancyOrder'] = {}, action: RepositActionTypes) => {
  if (action.type === FETCH_TENANCY_ORDER_NOTES_API_SUCCESS) {
    return {
      ...state,
      [action.payload.tenancyOrderId]: {
        ...state[action.payload.tenancyOrderId],
        tenancyOrderNotes: action.payload.tenancyOrderNoteIds,
      },
    };
  }

  if (action.type === DELETE_REPOSIT_NOTE_API_SUCCESS) {
    const newNotes = state[action.payload.tenancyOrderId].tenancyOrderNotes.filter(
      (tenancyOrderNoteId: string) => tenancyOrderNoteId !== action.payload.tenancyOrderNoteId,
    );
    return {
      ...state,
      [action.payload.tenancyOrderId]: {
        ...state[action.payload.tenancyOrderId],
        tenancyOrderNotes: newNotes,
      },
    };
  }
  return state;
};
